import PageMap from './PageMap'
export default PageMap
